import { ShareActionType } from '@/forwarding/constants/ShareActionType';

export function getShareActionTitle(type: ShareActionType, hasMultipleUrls: boolean): string {
  switch (type) {
    case ShareActionType.WhatsApp:
      return 'WhatsApp';
    case ShareActionType.AddToSpectrum:
      return 'Add to Light-Spectrum Demo';
    case ShareActionType.CopyLink:
      return hasMultipleUrls ? 'Copy Links' : 'Copy Link';
    case ShareActionType.CopyLinkWithInfo:
      return hasMultipleUrls ? 'Copy Links with Info' : 'Copy Link with Info';
    case ShareActionType.Email:
      return 'Email';
    case ShareActionType.QrCode:
      return 'QR Code';
    case ShareActionType.Facebook:
      return 'Facebook';
    case ShareActionType.Twitter:
      return 'Twitter';
    case ShareActionType.Pinterest:
      return 'Pinterest';
    case ShareActionType.NativeShare:
      return 'Native Share';
  }
}
